import React from 'react';

interface LogoProps {
  className?: string;
}

export const KharonLogo: React.FC<LogoProps> = ({ className }) => (
  <svg 
    id="Layer_2" 
    data-name="Layer 2" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 1173.21 154.22" 
    className={className} 
    fill="currentColor"
  >
    <g id="Capa_2" data-name="Capa 2">
      <g>
        {/* K Stem */}
        <path d="M.99,77.79c0,13.96-.33,28.95-.99,44.97h30.85V32.82H0c.66,16.02.99,31.01.99,44.97Z"/>
        {/* H */}
        <path d="M287.29,32.82v33.7h-45.59v-33.7h-29.11c.66,16.02.99,31.01.99,44.97s-.33,28.95-.99,44.97h29.11v-33.7h45.59v33.7h29.11c-.58-13.96-.87-28.95-.87-44.97s.29-31.01.87-44.97h-29.11Z"/>
        {/* R */}
        <path d="M735.58,81.01c3.51-4.96,5.27-11.03,5.27-18.21,0-9.17-3.3-16.43-9.91-21.8-6.61-5.37-18.25-8.05-34.94-8.05h-25.4v-.12h-29.24c.66,16.02.99,31.01.99,44.97s-.33,28.95-.99,44.97h29.24v-28.74h18.21c7.85,12.39,13.59,21.97,17.22,28.74h33.7l-20.07-27.88c-.41-.74-1.11-1.78-2.11-3.1,8.51-2.23,14.51-5.82,18.03-10.78ZM710.74,68.01c-1.41.99-3.9,1.71-7.5,2.17-3.59.46-8.9.68-15.92.68h-16.73v-14.12h16.73c7.1,0,12.47.21,16.11.62,3.63.41,6.11,1.12,7.43,2.11,1.32.99,1.98,2.4,1.98,4.21s-.7,3.34-2.11,4.34Z"/>
        {/* N */}
        <path d="M1173.21,32.95h-30.35l2.11,69.5-30.1-69.5h-45.59c.66,16.02.99,30.97.99,44.85s-.33,28.95-.99,44.97h31.84l-2.23-67.64,29.98,67.64h44.35c-.58-13.96-.87-28.95-.87-44.97s.29-30.89.87-44.85Z"/>
        {/* O */}
        <path d="M940.07,14.5c-9.35-9.35-21.78-14.5-35.01-14.5s-25.66,5.15-35.01,14.5l-27.6,27.6c-19.3,19.3-19.3,50.71,0,70.02l27.6,27.6c9.35,9.35,21.78,14.5,35.01,14.5s25.66-5.15,35.01-14.5l27.6-27.6c19.3-19.3,19.3-50.71,0-70.02l-27.6-27.6ZM946.45,90.91l-27.6,27.6c-3.81,3.81-8.8,5.71-13.79,5.71s-9.99-1.9-13.79-5.71l-27.6-27.6c-7.62-7.62-7.62-19.97,0-27.59l27.6-27.6c3.81-3.81,8.8-5.71,13.79-5.71s9.99,1.9,13.79,5.71l27.6,27.6c7.62,7.62,7.62,19.97,0,27.59Z"/>
        {/* A (Lambda style) */}
        <path d="M455.16,32.82l-34.69,89.94h31.1l6.19-17.72,7.17-19.33h-.11c5.62-15.2,9.87-26.55,12.76-34.07l2.97,8.05c3.3,8.67,6.52,17.34,9.66,26.02h-.07l7.13,19.33c2.64,7.1,4.75,13.01,6.32,17.72h32.09l-34.94-89.94h-45.59Z"/>
        {/* K Branch */}
        <path d="M64.42,71.47l39.02-38.65h-40.14c-6.31,8.98-16.84,20.79-31.56,35.41l13.52,22.4.08-.08c9,14.45,15.44,25.19,19.33,32.21h38.9c-5.87-7.1-12.41-15.4-19.64-24.9-7.23-9.5-13.73-18.29-19.51-26.39Z"/>
      </g>
    </g>
  </svg>
);
